import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import Accordion from "../../components/Accordion/Accordion";
import InfoGeneraliPerUtente from "./InfoGeneraliPerUtente";
import EsperienzeLavorativePerUtente from "./EsperienzeLavorativePerUtente";
import DisponibilitaOffertaPerUtente from "./DisponibilitaOffertaPerUtente";
import Button from "../../components/Button/Button";
import {useHistory} from "react-router";

function SchedaAssistente(props){

    const informazioniGenerali = (<div><InfoGeneraliPerUtente/></div>)
    const esperienzeLavorative = (<div><EsperienzeLavorativePerUtente/></div>)
    const disponibilitaOfferta = (<div><DisponibilitaOffertaPerUtente/></div>)
    const [datiAnagrafici,setDatiAnagrafici] = useState({nome:"",cognome:"",contatti:[]})
    const getAssistente = useSelector(state => state.wizardReducer)
    const history = useHistory()
    useEffect(() => {
        if (getAssistente && getAssistente.datiAnagrafici) {
            setDatiAnagrafici(getAssistente.datiAnagrafici)
        }
    }, [])

    function onClickButtonTornaAllaHome(){
        history.push({
            pathname:"/cercaAssistenteFamiliare"
        })
    }

    return (
        <div>
            {/* h1 di pagina (WCAG 1.3.1): l'intestazione visibile e' una riga di coppie
                etichetta/valore (Nome, Cognome, Cellulare), non un titolo promuovibile.
                Reso con .sr-only (bootstrap-italia) per non alterare la resa grafica. */}
            <h1 className={"sr-only"}>Scheda dell'assistente familiare</h1>
            <div style={{borderBottom:"3px solid #1b7ea9",marginTop:"2rem",marginBottom:"2rem"}}>
                <div className={"row"} style={{marginBottom:"1rem",marginLeft:"1rem",marginRight:"1rem"}}>
                    <div className={"col-2"}>
                        <span style={{fontSize:"20px"}}><b>Nome: </b>{datiAnagrafici.nome.toUpperCase()}</span>
                    </div>
                    <div className={"col-8"}>
                        <span style={{fontSize:"20px"}}><b>Cognome: </b>{datiAnagrafici.cognome.toUpperCase()}</span>
                    </div>
                    <div className={"col-2"}>
                        <span style={{fontSize:"20px"}}><b>Cellulare: </b>{datiAnagrafici.contatti[0] && datiAnagrafici.contatti[0].cellulare?datiAnagrafici.contatti[0].cellulare.toUpperCase():""}</span>
                    </div>
                </div>

            </div>
            <Accordion
                id={"AccordionInformazioniGenerali"}
                headerText={"Informazioni Generali"}
                accordionBody={informazioniGenerali}
            />
            <Accordion
                id={"AccordionEsperienzeLavorative"}
                headerText={"Esperienze Lavorative"}
                accordionBody={esperienzeLavorative}
            />
            <Accordion
                id={"AccordionDisponibilitaOfferta"}
                headerText={"Disponibilità Offerta"}
                accordionBody={disponibilitaOfferta}
            />
            <div style={{textAlign:"center"}}>
                <Button
                    id={"ButtonTornaAllaHome"}
                    onClick={onClickButtonTornaAllaHome}
                    typeButton={"Blue"}
                    text={"Torna ai risultati della ricerca"}
                    style={{minHeight:"50px",minWidth:"150px"}}
                />
            </div>
        </div>
    )



}
export default SchedaAssistente